import { IIcon } from '../interfaces'

const SvgComponent = ({ width = 20, height = 20, size, ...props }: IIcon) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 24 25'
    width={size || width}
    height={size || height}
    {...props}
  >
    <path
      fill='currentColor'
      d='M5 18.5v1-14zm.308 2.5q-.748 0-1.278-.53a1.74 1.74 0 0 1-.53-1.278V5.808q0-.748.53-1.278T5.308 4h13.384q.749 0 1.278.53.53.53.53 1.278v2.721H19V5.808a.3.3 0 0 0-.087-.221.3.3 0 0 0-.22-.087H5.307a.3.3 0 0 0-.221.087.3.3 0 0 0-.087.22v13.385a.3.3 0 0 0 .087.221.3.3 0 0 0 .22.087h13.385a.3.3 0 0 0 .221-.087.3.3 0 0 0 .087-.22V16.47h1.5v2.721q0 .749-.53 1.278-.53.53-1.278.53zm8-4q-.748 0-1.278-.53a1.74 1.74 0 0 1-.53-1.278V9.808q0-.749.53-1.278.53-.53 1.278-.53h6.384q.749 0 1.278.53.53.53.53 1.278v5.384q0 .749-.53 1.278-.53.53-1.278.53zm6.384-1.5a.3.3 0 0 0 .221-.086.3.3 0 0 0 .087-.222V9.808a.3.3 0 0 0-.087-.222.3.3 0 0 0-.22-.086h-6.385a.3.3 0 0 0-.222.086.3.3 0 0 0-.086.222v5.384a.3.3 0 0 0 .086.222.3.3 0 0 0 .222.086zM16 14q.625 0 1.063-.437.437-.438.437-1.063t-.437-1.062A1.45 1.45 0 0 0 16 11q-.625 0-1.062.438A1.45 1.45 0 0 0 14.5 12.5q0 .624.438 1.063Q15.375 14 16 14'
    />
  </svg>
)
export default SvgComponent
